import shirt01 from "../img/shirt01.png";

export const productdata = [
  {
    productId: 1,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679210/obebfx7zwgoam1rymsfq.png",
    price: 99.99,
    discount: 20,
    size: "S",
    color: "Red",
    type: "Shirt",
    launchDate: "2022-01-01",
    productName: "Printed Regular fit Shirt ",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
  {
    productId: 2,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679211/getbcer9zs8e5nvysvaj.png",
    price: 49.99,
    discount: 0,
    size: "M",
    color: "Red",
    type: "Pants",
    launchDate: "2022-02-15",
    productName: "Round Neck Cotton Blend Plain T-Shirt",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
  {
    productId: 3,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679210/l21ug0lwzhewzgg9wp9n.png",
    price: 149.99,
    discount: 30,
    size: "L",
    color: "Black",
    type: "Jacket",
    launchDate: "2022-03-30",
    productName: "Printed Round Neck Half Sleeve Casual Wear T-Shirt",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
  {
    productId: 4,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679210/cvib1ib8qzdtkgupvonn.png",
    price: 24.99,
    discount: 10,
    size: "XS",
    color: "YBlue",
    type: "Hat",
    launchDate: "2022-04-12",
    productName: "Cotton Loose Fit Half Sleeves T-Shirt",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
  {
    productId: 5,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679210/oeefphmaw0i2az7eapso.png",
    price: 24.99,
    discount: 10,
    size: "XS",
    color: "Red",
    type: "Hat",
    launchDate: "2022-04-12",
    productName: "Round Neck Full Sleeve Fan Art Theme Cotton T-Shirt",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
  {
    productId: 6,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679211/b8lv32z8nnpi5psxqzie.png",
    price: 24.99,
    discount: 10,
    size: "XS",
    color: "Green",
    type: "Hat",
    launchDate: "2022-04-12",
    productName: "Urbano Fashion Full Sleeve Cotton T-Shirt",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
  {
    productId: 7,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679212/usykndcgmtlwmggfbzeq.png",
    price: 24.99,
    discount: 10,
    size: "XS",
    color: "Brown",
    type: "Hat",
    launchDate: "2022-04-12",
    productName: "Urbano Fashion Full Sleeve Cotton T-Shirt",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
  {
    productId: 8,
    productImage:
      "https://res.cloudinary.com/deuoakrwt/image/upload/v1703679211/getbcer9zs8e5nvysvaj.png",
    price: 24.99,
    discount: 10,
    size: "XS",
    color: "White",
    type: "Hat",
    launchDate: "2022-04-12",
    productName: "Casual Plain Cotton Tshirt",
    productDescription:
      "Introducing our new regular fit long sleeve shirt, the perfect combination of comfort and style. Made with high-quality materials, this shirt will keep you looking sharp while feeling relaxed. Dress it up for a night out or dress it down for a casual day, this versatile shirt will quickly become a wardrobe staple. Don't miss out on the opportunity to upgrade your wardrobe with this must-have piece!",
  },
];
